import React from 'react';
import { Player, PlayerStats, Game, LightPlayer, PlayerStats2 } from '../../types/types';
import styled from 'styled-components';
import { Paper, Tooltip } from '@mui/material';
import { TeamLogos, TeamsList, TOOLTIPS } from '../../globals/Globals';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import PlayerCardPopover from './PlayerCardPopover';
import { useTheme } from '@mui/material/styles';
import { IMAGES_BUCKET } from '../../configs/consts';

export interface Props {
    player: LightPlayer;
    stats?: PlayerStats;
    width: string;
    onPlusClick: (player: Player) => void;
    onNavClick: (player: Player) => void;
    removeIcon?: boolean;
    headerElement?: React.ReactNode;
}

const CardNumber = styled.b`
    font-size: 1rem;
    @media (min-width: 1024px) {
        font-size: 1.1rem ;
    }
`

const CardLabel = styled.span`
    font-size: 0.75rem;
    line-height: 1;
    @media (min-width: 1024px) {
        font-size: 0.9rem;
    }
`

function PlayerCard({player, stats, width, onPlusClick, onNavClick, removeIcon, headerElement}:Props) {
    const theme = useTheme();
    if (!player.stats[0]) {
        return null
    }
    const lastgame:Game = player.stats[0].lastgame;
    const stat:PlayerStats2 = player.stats[0];
    const team = lastgame?.team?.name? lastgame.team.name : '';
    const colors = TeamsList[team]? TeamsList[team] : ['',''];
    const playerimg = `${IMAGES_BUCKET}${player.firstname}-${player.lastname}.png`;
    const teamLogo = TeamLogos[team]? TeamLogos[team] : '';
    //Todo Implement increase logic
    const increase = stat.price_change > -1;
    const pricestring = stat.price.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0});


    const CardItems = [
        {label: 'PTS', value: lastgame?.fiveRoundAverage? lastgame.fiveRoundAverage : '\u00A0'},
        {label: '3Ra', value: lastgame?.threeRoundAverage? lastgame.threeRoundAverage : '\u00A0'},
        {label: 'BE', value: lastgame?.scbe? lastgame.scbe : '\u00A0'},
    ]

    return <Paper style={{width: width, minWidth: width, textAlign: "center", cursor: "pointer"}} className="playercard" elevation={3}>
        {headerElement? headerElement : ''}
        <a href={`/player/${player.id}`}>
        
        <div style={{position: "relative"}}>
        
        <div style={{
            background: `linear-gradient(120deg, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%)`,
            borderTopRightRadius: 4,
            borderTopLeftRadius: 4,
        }}>
            <div style={{
                backgroundImage: `url("${playerimg}")`,
                backgroundSize: "contain",
                backgroundPosition: "center center",
                paddingBottom: "60%",
                backgroundRepeat:"no-repeat",
                //backgroundColor: "blue",
                borderTopRightRadius: 4,
                borderTopLeftRadius: 4
            }}>
                <div style={{position: "absolute", top: 6, left: 6}}>
                    <div style={{display:"flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start"}}>        
                        { /* <span style={{color: "white"}}>{player.stats[0]?.last5Games[0]?.team?.name}</span> */ }
                        <img style={{width: "30px", height: "30px"}} src={teamLogo} alt={team}/>
                    </div>
                </div>
                
            </div>
        </div>
        </div>
        </a>
        <Paper>
            <a href={`/player/${player.id}`}>
                <div style={{display: "flex", flexDirection: "column", marginTop: "0.5rem",marginBottom: "0.5rem"}}>
                    <span>
                        <b style={{color: theme.palette.mode === 'dark' ? 'white' : "black"}}>
                            {player.firstname[0]}. {player.lastname}
                        </b>
                    </span>
                    <span style={{display: "flex",width: "100%",justifyContent: "center",marginTop: '0.25rem'}}>
                        <b style={{color: increase ? "green" : 'red'}}>{pricestring}</b> 
                        {increase ? <TrendingUpIcon style={{color: "green", marginLeft: "0.25rem"}} /> : <TrendingDownIcon style={{color: "red", marginLeft: "0.5rem"}}/> }</span>
                </div>
            </a>
            <div style={{display: "grid", gridTemplateRows: "1fr", gridTemplateColumns: "1fr 1fr 1fr", gridRowGap: "0.5rem", paddingBottom: "1rem"}}>
                {CardItems.map(function(item) {
                    return (<Tooltip title={TOOLTIPS[item.label]} placement="top">
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div><CardNumber>{item.value}</CardNumber></div>
                        <CardLabel>{item.label}</CardLabel>                    
                    </div>
                </Tooltip>)
                })}
            </div>
        </Paper>
    </Paper>
};

export default PlayerCard;